import React from 'react';
import { BsPlayFill } from 'react-icons/bs';
import { getStartedData } from './data';

interface IProps {}

const GetStarted: React.FC<IProps> = ({}) => {
  const [showAccord, setShowAccord] = React.useState(0);
  const handleAccord = (id: number) => setShowAccord(id);
  return (
    <div className="bg-pure-white rounded-xl border border-border-color-dark">
      {getStartedData.map((item) => (
        <div
          className="border-b border-border-color-dark last:border-none p-5"
          key={item?.id}
          onClick={() => handleAccord(item?.id)}
        >
          <div className="flex items-center space-x-4 cursor-pointer">
            {item?.id === showAccord ? (
              <BsPlayFill
                color="#4062FF"
                size={24}
                style={{ transform: 'rotate(90deg)' }}
              />
            ) : (
              <BsPlayFill color="#4062FF" size={24} />
            )}{' '}
            <h6 className="text-black"> {item?.title} </h6>
          </div>
          {item?.id === showAccord && (
            <p className="text-light-grey px-8 my-4"> {item?.subTitle} </p>
          )}
        </div>
      ))}
      <div className=""></div>
    </div>
  );
};

export default React.memo(GetStarted);
